export const Button = {
  variants: {
    primary: (): any => ({
      backgroundColor: 'brand.500',
      color: 'white',
    }),
  },
};
